var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
// Create a new component status
export function createComponentStatus(data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post('/api/internal/component_statuses', {
                component_status: {
                    status: data.status,
                    color: data.color,
                    active: true,
                    is_default: false,
                    description: data.description
                }
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error creating component status:', error);
            return {
                error: {
                    message: 'Failed to create component status'
                }
            };
        }
    });
}
// Get all component statuses
export function getComponentStatuses() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/component_statuses');
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching component statuses:', error);
            return {
                error: {
                    message: 'Failed to fetch component statuses'
                }
            };
        }
    });
}
// Update an existing component status
export function updateComponentStatus(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = {};
            if (data.status !== undefined) {
                requestData.status = data.status;
            }
            if (data.color !== undefined) {
                requestData.color = data.color;
            }
            if (data.description !== undefined) {
                requestData.description = data.description;
            }
            const response = yield api.patch(`/api/internal/component_statuses/${id}`, {
                component_status: requestData
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating component status:', error);
            return {
                error: {
                    message: 'Failed to update component status'
                }
            };
        }
    });
}
// Set a component status as default
export function setComponentStatusAsDefault(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/component_statuses/${id}`, {
                component_status: {
                    is_default: true
                }
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error setting component status as default:', error);
            return {
                error: {
                    message: 'Failed to set component status as default'
                }
            };
        }
    });
}
// Delete a component status
export function deleteComponentStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.delete(`/api/internal/component_statuses/${id}`);
            return {};
        }
        catch (error) {
            console.error('Error deleting component status:', error);
            return {
                error: {
                    message: 'Failed to delete component status'
                }
            };
        }
    });
}
// Update position of a component status
export function updateComponentStatusPosition(id, position) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/component_statuses/${id}`, {
                component_status: {
                    position
                }
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating component status position:', error);
            return {
                error: {
                    message: 'Failed to update component status position'
                }
            };
        }
    });
}
export function batchReorderComponentStatuses(updates) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post('/api/internal/component_statuses/batch_reorder', {
                updates
            });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error batch reordering component statuses:', error);
            return {
                error: {
                    message: 'Failed to reorder component statuses'
                }
            };
        }
    });
}
// Export default object with all functions
export default {
    createComponentStatus,
    getComponentStatuses,
    updateComponentStatus,
    setComponentStatusAsDefault,
    deleteComponentStatus,
    updateComponentStatusPosition,
    batchReorderComponentStatuses
};
